import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const MicrophoneOffIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M11.5731 8.20545C11.8463 8.2458 12.0351 8.49997 11.9947 8.77315C11.9027 9.39624 11.6269 10.3417 10.9423 11.1408C10.3151 11.8728 9.36984 12.4511 8.00007 12.5645V14.2001C8.00007 14.4762 7.77621 14.7001 7.50007 14.7001C7.22393 14.7001 7.00007 14.4762 7.00007 14.2001V12.5645C6.83791 12.5511 6.68169 12.5311 6.53125 12.5052L7.45708 11.5845L7.50007 11.5847C8.85657 11.5847 9.67532 11.0825 10.1829 10.4901C10.7065 9.87897 10.9308 9.13212 11.0054 8.62701C11.0458 8.35383 11.3 8.16509 11.5731 8.20545Z"
      fill="currentColor"
    />
    <path
      d="M3.0058 8.77315C2.96544 8.49997 3.15418 8.2458 3.42736 8.20545C3.70054 8.16509 3.95471 8.35383 3.99506 8.62701C4.02134 8.80489 4.06618 9.01275 4.13612 9.23412L3.36238 10.0171C3.1628 9.55686 3.05647 9.11616 3.0058 8.77315Z"
      fill="currentColor"
    />
    <path
      d="M6.08309 2.61678C5.6942 3.00567 5.49975 3.47789 5.49975 4.03345V7.87195L9.49382 3.86783C9.45854 3.38345 9.26607 2.96643 8.91642 2.61678C8.52753 2.22789 8.05531 2.03345 7.49975 2.03345C6.9442 2.03345 6.47198 2.22789 6.08309 2.61678Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M12.7707 3.51479C12.9237 3.66781 12.9237 3.91591 12.7707 4.06893L2.58297 14.2567C2.42995 14.4097 2.18185 14.4097 2.02883 14.2567C1.87581 14.1037 1.87581 13.8556 2.02883 13.7025L12.2166 3.51479C12.3696 3.36177 12.6177 3.36177 12.7707 3.51479Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
